import { useTypedParams } from '@sorare/routing';

import { PrizePoolContenderPage } from '@sorare/gameplay/src/pages/PrizePoolContenderPage';

import type { PageParams } from './__generated__/routeParams';

const MLBPrizePoolContenderPage = () => {
  const { leaderboard, contender } = useTypedParams<PageParams>();

  return (
    <PrizePoolContenderPage leaderboard={leaderboard} contender={contender} />
  );
};

export default MLBPrizePoolContenderPage;
